import { decode, encode } from 'querystring';
import history from 'State/history';

const QueryUrl = url => decode(url.search.substr(1));
export const currentSearchUrl = url => url.search;

const Query = () => QueryUrl(window.location);
export const currentSearch = () => currentSearchUrl(window.location);

const QueryVal = (key, defaultValue = null) => {
  const parsed = Query();

  if (key in parsed) {
    return parsed[key];
  }

  return defaultValue;
};

const QueryValUrl = (url, key, defaultValue = null) => {
  const parsed = QueryUrl(url);

  if (key in parsed) {
    return parsed[key];
  }

  return defaultValue;
};

const encodeQuery = input => `?${encode(input)}`;
const decodeQuery = input => decode(input.substr(1));

export const getLinkQueryParamUrl = (collection, linkQueryParamName) => {
  const linkQueryParamValue = QueryVal(linkQueryParamName);
  if (!linkQueryParamValue) {
    return new URL(collection.link('self').url());
  }
  return new URL(linkQueryParamValue);
};

/**
 * @param {...Object} query
 */
const addQuery = (...query) => {
  const params = decodeQuery(history.location.search);

  query.forEach((q) => {
    const key = Object.keys(q)[0];
    params[key] = q[key];
  });

  history.push({
    pathname: history.location.pathname,
    search: encodeQuery(params),
  });
};

/**
 * @param {...Object} query
 */
const addQueryWithReplace = (...query) => {
  const params = decodeQuery(history.location.search);

  query.forEach((q) => {
    const key = Object.keys(q)[0];
    params[key] = q[key];
  });

  history.replace({
    pathname: history.location.pathname,
    search: encodeQuery(params),
  });
};

/**
 * @param {...String} queryNames
 */
const removeQuery = (...queryNames) => {
  const params = decodeQuery(history.location.search);
  queryNames.forEach(q => delete params[q]);
  history.push({
    pathname: history.location.pathname,
    search: encodeQuery(params),
  });
};

/**
 * @param {...String} queryNames
 */
const removeQueryWithReplace = (...queryNames) => {
  const params = decodeQuery(history.location.search);
  queryNames.forEach(q => delete params[q]);
  history.replace({
    pathname: history.location.pathname,
    search: encodeQuery(params),
  });
};

/**
 * Returns a list of query param objects as an object.
 * `queryParams` must be an array of objects with keys `name`, indicating the query value name, and `encoded`,
 * indicating whether or not it needs to be decoded.
 * @param queryParams {Array<{ name: string, encoded: boolean }>} An array of name/encoded pairs.
 * @returns { Object } An object where the keys are query parameter names mapped to their values.
 */
const getQueryParams = queryParams => queryParams.reduce((params, { name, encoded }) => {
  if (encoded) {
    // eslint-disable-next-line no-param-reassign
    params[name] = atob(QueryVal(name));
  } else {
    // eslint-disable-next-line no-param-reassign
    params[name] = QueryVal(name);
  }

  return params;
}, {});

/** Helper function to get a URL query param as a URL safely */
const getUrlFromParamSafely = (queryName) => {
  const urlParam = QueryVal(queryName);
  if (!urlParam) {
    return null;
  }
  try {
    return new URL(urlParam);
  } catch (e) {
    // Bad url param protection
    removeQueryWithReplace(queryName);
  }
  return null;
};

export {
  QueryVal,
  Query,
  QueryValUrl,
  encodeQuery,
  decodeQuery,
  addQuery,
  removeQuery,
  removeQueryWithReplace,
  addQueryWithReplace,
  getQueryParams,
  getUrlFromParamSafely,
};
